"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebhookPayloadEnvelopeV1Schema = exports.UtmAttributionSchema = exports.WebhookApiVersionV1 = void 0;
const zod_1 = require("zod");
exports.WebhookApiVersionV1 = '2026-06-01';
exports.UtmAttributionSchema = zod_1.z
    .object({
    source: zod_1.z.string().min(1).optional(),
    medium: zod_1.z.string().min(1).optional(),
    campaign: zod_1.z.string().min(1).optional(),
    content: zod_1.z.string().min(1).optional(),
    term: zod_1.z.string().min(1).optional(),
    sck: zod_1.z.string().min(1).optional(),
    src: zod_1.z.string().min(1).optional(),
})
    .strict();
exports.WebhookPayloadEnvelopeV1Schema = zod_1.z
    .object({
    id: zod_1.z.string().min(1),
    type: zod_1.z.string().min(1),
    apiVersion: zod_1.z.literal(exports.WebhookApiVersionV1),
    createdAt: zod_1.z.string().datetime({ offset: true }),
    data: zod_1.z.unknown(),
})
    .strict();
//# sourceMappingURL=webhook-payloads.js.map